import React, { useState } from "react";
import { ReactComponent as CheckIcon } from "../../assets/images/check-green.svg";
import { ReactComponent as ClockIcon } from "../../assets/images/timer.svg";
import {
    BookingFlowLayout,
    BookingFlowPageHeading,
    BookingFlowPrimaryButton,
    bookingFlowSelectableCardStyles,
    BookingFlowSelectableCard,
} from "../../components/booking-flow";
import useAnalytics from "../../hooks/analytics";
import useLanguage from "../../hooks/language";
import { trackBookingFlowLabSelected } from "../../utils/analytics/booking-flow-tracking";
import footnoteStyles from "../../components/booking-flow/booking-flow-primary-button.module.css";

export default function HpvServicePageV2({
    onSubmit,
}: {
    onSubmit: () => void;
}): React.ReactElement {
    const [analytics] = useAnalytics();
    const { translations } = useLanguage();
    const tPage = translations.hpvServicePage;
    const tBooking = translations.bookingFlow.hpvService;
    const tDetails = tPage.details;
    const [hpvSelected, setHpvSelected] = useState(true);

    return (
        <BookingFlowLayout currentStep="lab" skipConsultationStep>
            <BookingFlowPageHeading
                title={tPage.title}
                subtitle={tPage.description}
                responsive
            />

            <BookingFlowSelectableCard
                checked={hpvSelected}
                onSelect={() => setHpvSelected(true)}
                variant="dark"
                icon={<ClockIcon />}
                headline={tDetails.title}
            >
                <ul className={bookingFlowSelectableCardStyles.bulletList}>
                    <li className={bookingFlowSelectableCardStyles.bulletRow}>
                        <CheckIcon
                            className={
                                bookingFlowSelectableCardStyles.bulletIcon
                            }
                            aria-hidden
                        />
                        <span
                            className={
                                bookingFlowSelectableCardStyles.bodyTextDark
                            }
                        >
                            {tDetails.info1}
                        </span>
                    </li>
                    <li className={bookingFlowSelectableCardStyles.bulletRow}>
                        <CheckIcon
                            className={
                                bookingFlowSelectableCardStyles.bulletIcon
                            }
                            aria-hidden
                        />
                        <span
                            className={
                                bookingFlowSelectableCardStyles.bodyTextDark
                            }
                        >
                            {tDetails.info2}
                        </span>
                    </li>
                </ul>
                <p
                    className={bookingFlowSelectableCardStyles.bodyTextDark}
                    style={{ marginTop: 16, marginBottom: 0 }}
                >
                    <strong>{tDetails.price}</strong>{" "}
                    <span style={{ opacity: 0.82 }}>{tDetails.priceNote}</span>
                </p>
            </BookingFlowSelectableCard>

            <p className={footnoteStyles.footnote}>{tDetails.footnote}</p>

            <BookingFlowPrimaryButton
                disabled={!hpvSelected}
                onClick={() => {
                    if (!hpvSelected) {
                        return;
                    }
                    trackBookingFlowLabSelected(analytics, "private");
                    onSubmit();
                }}
            >
                {tBooking.continueButton}
            </BookingFlowPrimaryButton>
        </BookingFlowLayout>
    );
}
